import { createFileRoute, redirect } from '@tanstack/react-router';
import { SearchResultsBody } from '@/components/global-search/SearchResultsBody';
import { isPublicSearchResultsType } from '@/components/global-search/types';

type SearchPageSearch = {
  q?: string;
  type?: 'all' | 'members' | 'groups' | 'events' | 'resources' | 'posts' | 'messages';
};

function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}

function parseType(v: unknown): SearchPageSearch['type'] {
  return v === 'all' ||
    v === 'members' ||
    v === 'groups' ||
    v === 'events' ||
    v === 'resources' ||
    v === 'posts' ||
    v === 'messages'
    ? v
    : undefined;
}

// Under `_public`: members search everything they can see, logged-out
// visitors the public directories (SearchResultsBody picks the surface).
export const Route = createFileRoute('/_public/search/')({
  validateSearch: (raw: Record<string, unknown>): SearchPageSearch => ({
    ...(pickStr(raw.q) !== undefined ? { q: pickStr(raw.q) as string } : {}),
    ...(parseType(raw.type) !== undefined
      ? { type: parseType(raw.type) }
      : {}),
  }),
  // A member's shared `?type=messages` link opened logged out lands on the
  // public surface's All tab, keeping the query.
  beforeLoad: ({ context, search }) => {
    if (
      context.session === null &&
      search.type !== undefined &&
      !isPublicSearchResultsType(search.type)
    ) {
      throw redirect({
        to: '/search',
        search: search.q !== undefined ? { q: search.q } : {},
        replace: true,
      });
    }
  },
  component: SearchPage,
});

function SearchPage() {
  return <SearchResultsBody />;
}
